import { cn } from '@/lib/utils';
import { PropsWithChildren } from 'react';

interface TagItemProps extends PropsWithChildren {
  active?: boolean;
  label?: string;
  className?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const TagItem = ({
  active,
  label,
  className,
  disabled,
  onClick,
  children,
}: TagItemProps) => {
  return (
    <div className={cn(
      "text-xs font-medium text-[rgba(0,0,0,1)] border border-[rgba(233,234,235,1)] rounded-[6px] px-[10px] py-2 cursor-pointer hover:bg-[rgba(0,0,0,0.05)] transition-all",
      disabled && "cursor-not-allowed text-[rgba(0,0,0,0.5)]",
      active && "border-[rgba(0,0,0,1)] bg-[rgba(0,0,0,0.05)]",
      className
    )}
      onClick={disabled ? undefined : onClick}
    >
      {children || label}
    </div>
  )
}
